// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".e-new-version-informer__btn[data-v-180cf0a8]{color:#ff8a00}", ""]);
// Exports
module.exports = exports;
